import React from 'react';
import PropTypes from 'prop-types';

import BoxscoreSide from './BoxscoreSide';

const Boxscore = ({ boxscore }) => {
  return (
    <div className="s-game-explorer__boxscore box box--has-border">
      <BoxscoreSide key="visitor" side={boxscore.visitor} label="Visitor" />
      <BoxscoreSide key="home" side={boxscore.home} label="Home" />
    </div>
  );
};

Boxscore.propTypes = {
  visitor: PropTypes.object,
  home: PropTypes.object,
};

export default Boxscore;
